import {openResurvaModal} from '../openResurvaModal'

export function initBookAppointmentPage() {
	const $button = $('.book-appointment-location__button').once('initBookAppointmentPage')
	$button.on('click', function () {
		const embedCode = $(this).data('embedCode')
		if(!embedCode) {
			// TODO Add toast warning?
			return
		}
		openResurvaModal(embedCode)
	})
}